import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideAppInitializer,
  inject,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { environment } from '../environments/environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { routes } from './app.routes';
import { authInterceptor } from './core/interceptors';
import Aura from '@primeuix/themes/aura';
import { providePrimeNG } from 'primeng/config';
import { I18nStore } from './core/features/translations';
import { AuthService } from './services/auth.service';

/**
 * Application Configuration
 *
 *
 * APP_INITIALIZER to ensure I18n is loaded before app starts
 */
export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      unstyled: true,
    }),

    // Simplified I18n initialization
    provideAppInitializer(() => {
      const i18n = inject(I18nStore);
      const auth = inject(AuthService);

      if (auth.isAuthenticated()) {
        return i18n.refreshTranslations();
      }
      return Promise.resolve();
    }),
  ],
};
